// extracted by mini-css-extract-plugin
module.exports = {"exploreSimilarEventsButton":"ExploreSimilarEventsButton_exploreSimilarEventsButton__PNjGa"};